
<div class="container-fluid page">
  <div class="d-flex page__box p-3 mt-2"><img src="./assets/arrow_logo.png" class="arrow" (click)="listPage()">&nbsp;&nbsp;Fertilizer Application Reminder</div>
  <div class="example-header">
    <mat-card class="matCardForm">
      <mat-card-content class="pa-1">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="fulllwidth">
            

            <mat-form-field>
              <textarea type="text" required formControlName="notification" style="height: 50px;" maxlength="300" rows="5" matInput
                placeholder="Type notification text here (300 characters maximum)"></textarea>
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>Target users in these states* (minimum one)</mat-label>
              <mat-select formControlName="fcstates" multiple required>
                <mat-option *ngFor="let state of states" [value]="state">{{state}}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field>
              <input type="text" formControlName="attachlink" id="attachlink" matInput placeholder="Attach Link">
            </mat-form-field>

            <mat-form-field>
              <input type="text" formControlName="Remark" placeholder="Remark" matInput>
            </mat-form-field>
            
            <div class="row">
              <div class="col-md-8">
              </div>
              <div class="col-md-4">
                <button mat-button type="submit" [disable]="disable" class="submitBtn">Send Reminder</button>
              </div>
            </div>

          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>